import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import Drawer from "../../common/Drawer";
import { Heading } from "../../../styles/component/style";
import CustomTable from "../../common/CustomTable/CustomTable";
import CaseService from "../../../services/CaseService";
import moment from "moment";
// import AgreementDrawer from "./AgreementDrawer";
import queryString from "query-string";
import {
  getErrorMessage,
  parseTimeStamp,
  getFileFormat,
} from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { makeStyles, Tooltip } from "@material-ui/core";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import useLoader from "../../../hooks/useLoader";
import AlertDialog from "../../common/Alert";
import DrawerRecording from "../ViewRecording/ViewRecording";
import DocTypeChange from "../DocumentTypeChange/DocTypeChange";
import HttpsLockOpen from "@material-ui/icons/LockOpen";
import HttpsIcon from "@material-ui/icons/Https";
import PublicIcon from "@material-ui/icons/Public";
import DocVisibilityTypeChange from "../DocVisibilityTypeChange/index";
import AudioRecordings from "../MeetingAudioDetails/index";
import HearingBundles from "../HearingBundles/index";
import DocViewer from "./DocViewer";
import ViewKeywords from "./ViewExtract";
import WhatsAppIcon from "./component/WhatsAppIcon";
import AddDocument from "./AddDocument";
import { hydratePdfPageCounts } from "../../../helpers/pdfPageCountCache";

const getExhibitId = (doc) => {
  if (!doc) return null;
  return doc.exhibitId || doc.exhibit_id || doc.exhibitCode || doc.exhibit_code || doc.properties?.exhibitId || doc.properties?.exhibit_id || doc.properties?.exhibitNo || doc.properties?.exhibit_no || null;
};

const docTypes = [
  { ownerType: "claimant", title: "Claimant Documents" },
  { ownerType: "respondent", title: "Respondent Documents" },
  { ownerType: "common", title: "Neutral’s Documents" },
];

async function getCaseDocument(id, query) {
  try {
    const response = await CaseService.getcaseDocuments(id, query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const Index = ({
  state,
  setState,
  id,
  type,
  claimantId,
  respondentId,
  agreementsAndAwards,
  isActionsDisabled,
  caseDetails,
  title,
  viewOnly,
}) => {
  return (
    <Drawer state={state} setState={setState} label="Drawer">
      <Table
        {...{
          setState,
          id,
          type,
          claimantId,
          respondentId,
          agreementsAndAwards,
          isActionsDisabled,
          caseDetails,
          title,
          viewOnly,
        }}
      />
    </Drawer>
  );
};

export default Index;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f9f9f9",
    border: "solid 0.5px #e1e3ee",
    boxShadow: "none",
    margin: "16px 0px 0px !important",
    "& .MuiExpansionPanelSummary-content": {
      margin: "27px 0 27px 24px !important",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: 15,
      backgroundColor: "#fff",
    },
    "& .MuiSvgIcon-root": {
      fill: "#00838c",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Table = ({
  setState,
  id,
  type,
  agreementsAndAwards,
  caseDetails,
  isActionsDisabled,
  title,
  viewOnly,
}) => {
  const [documents, setDocuments] = useState({});
  const [trigger, setTrigger] = useState(false);
  const [urls, setUrls] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    if (!id) return;

    let isActive = true;

    const preloadCaseDocumentPageCounts = async () => {
      try {
        const response = await CaseService.getDocumentList(id);
        if (isActive) hydratePdfPageCounts(response?.documentList || []);
      } catch (error) {
        // Background warming should never interrupt opening a case.
        console.error("Document page count preload failed:", error);
      }
    };

    preloadCaseDocumentPageCounts();

    return () => {
      isActive = false;
    };
  }, [id]);

  const handleAccordionChange = (ownerType) => (event, isExpanded) => {
    setExpanded((prev) => ({ ...prev, [ownerType]: isExpanded }));
  };

  const handleDownload = async () => {
    try {
      const directoryHandle = await window.showDirectoryPicker();
      for (const { url, filename } of urls) {
        const response = await fetch(url);
        const blob = await response.blob();
        await writeFile(directoryHandle, filename, blob);
      }
      enqueueSnackbar("Files downloaded successfully to selected folder.", {
        variant: "success",
      });
    } catch (err) {
      console.error("Error downloading files:", err);
      enqueueSnackbar("Failed to download files.", { variant: "error" });
    } finally {
      setTrigger(true);
      setUrls([]);
    }
  };

  const writeFile = async (directoryHandle, filename, blob) => {
    const fileHandle = await directoryHandle.getFileHandle(filename, {
      create: true,
    });
    const writable = await fileHandle.createWritable();
    await writable.write(blob);
    await writable.close();
  };

  return (
    <div>
      <Header>
        <Heading
          style={{
            marginBottom: "unset",
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          Case Documents
          {viewOnly !== true && (
            <>
              <AddDocument
                {...{ id, caseDetails, isActionsDisabled, setTrigger }}
              />
              <WhatsAppIcon {...{ id, isActionsDisabled, title }} />
            </>
          )}
          {urls.length > 0 && viewOnly !== true && (
            <Card>
              <div className="add_circle" onClick={handleDownload}>
                <img
                  src={require("../../../assets/images/JustAct Icons Download-02.svg")}
                  alt="download"
                />
              </div>
            </Card>
          )}
        </Heading>
        <ImageWrapper>
          <img
            src={require("../../../assets/images/closeModal.svg")}
            onClick={() => setState(false)}
            alt="close"
          />
        </ImageWrapper>
      </Header>

      <AccordionContainer>
        {docTypes
          .filter((item) =>
            type === "negotiation" ? item.ownerType !== "mediator" : true,
          )
          .map((item) => (
            <TableWithAccordion
              key={item.ownerType}
              {...item}
              id={id}
              setState={setState}
              type={type}
              setDocuments={setDocuments}
              trigger={trigger}
              setTrigger={setTrigger}
              setUrls={setUrls}
              caseDetails={caseDetails}
              viewOnly={viewOnly}
              isExpanded={!!expanded[item.ownerType]}
              onAccordionChange={handleAccordionChange(item.ownerType)}
            />
          ))}

        {id && (
          <HearingBundles
            title="Hearing Bundles"
            id={id}
            documents={documents}
            viewOnly={viewOnly}
          />
        )}

        {type !== "negotiation" && viewOnly !== true && (
          <DrawerRecording
            title="View Recordings"
            id={id}
            setState={setState}
            type={type}
          />
        )}

        {/* {type !== "negotiation" && (
          <AgreementDrawer
            title="Template Agreements and Awards"
            id={id}
            setState={setState}
            type={type}
            agreementsAndAwards={agreementsAndAwards}
          />
        )} */}

        {type !== "negotiation" && viewOnly !== true && (
          <AudioRecordings id={id} type={type} />
        )}
      </AccordionContainer>
    </div>
  );
};

function TableWithAccordion({
  id,
  title,
  ownerType,
  setState,
  type,
  setDocuments,
  trigger,
  setTrigger,
  setUrls,
  caseDetails,
  viewOnly,
  isExpanded,
  onAccordionChange,
}) {
  const classes = useStyles();
  const [result, setResult] = useState({
    data: [],
    total: 0,
    page: 1,
    perPage: 10,
    lastPage: 1,
  });
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const MTRef = useRef(null);
  const [rowData, setDatas] = useState(null);
  const [modal, setModal] = useState(false);
  const [docview, setDocView] = useState({ state: false });
  const [view, setView] = useState({ state: false });

  useEffect(() => {
    if (isExpanded && MTRef.current) {
      // MTRef.current.onQueryChange({ page: 0, pageSize: 10 });
    } else if (!isExpanded) {
      setResult({ data: [], total: 0, page: 1, perPage: 10, lastPage: 1 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded]);

  useEffect(() => {
    if (trigger && isExpanded && MTRef.current) {
      MTRef.current.onQueryChange(MTRef.current.state?.query || {});
      setTrigger(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, isExpanded]);

  useEffect(() => {
    setDocuments((prev) => ({ ...prev, [ownerType]: result.total }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.total, ownerType]);

  const deleteDocument = async ({ entityId, id }) => {
    try {
      setLoader({ state: true, message: "Deleting document..." });
      const res = await CaseService.deleteDocument(entityId, id);
      if (res?.message) {
        enqueueSnackbar(res.message, { variant: "success" });
        if (MTRef.current && isExpanded) {
          MTRef.current.onQueryChange({});
        }
      }
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    } finally {
      setLoader({ state: false });
      setOpen(false);
    }
  };

  const openConfirmDelete = (data) => {
    setOpen(true);
    setDialogData({
      primaryBtnText: "Cancel",
      secondaryBtnText: "OK",
      clickSecondarybtn: () => deleteDocument(data),
      clickPrimaryBtn: () => setOpen(false),
      onDialogClose: () => setOpen(false),
      desc: "Are you sure you want to delete this document?",
      heading: "Delete Document",
      descriptionTextStyle: {
        textAlign: "left",
        fontFamily: theme.fonts.primaryFontSemiBold,
      },
    });
  };

  const columns = [
    {
      field: "documentNo",
      title: "Doc ID",
      sorting: false,
      hidden: viewOnly,
      width: 140,
      headerStyle: { padding: "12px 16px", textAlign: "left" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) => {
        const isCaseManagerEditable =
          ownerType === "common" && rowData?.ownerType === "caseManager";
        const isPrivate = rowData?.visibilityType === "me";
        const isShared = rowData?.visibilityType === "others";
        const getVisibilityIcon = () => {
          if (isPrivate) {
            return {
              Icon: HttpsIcon,
              title: "Private",
              clickable: isCaseManagerEditable,
            };
          }
          if (isShared) {
            return {
              Icon: HttpsLockOpen,
              title:
                ownerType === "common" && rowData?.ownerType === "caseManager"
                  ? "Shared with Neutral"
                  : "Shared with CM and Neutral",
              clickable: isCaseManagerEditable,
            };
          }
          return {
            Icon: PublicIcon,
            title: "Public",
            clickable: isCaseManagerEditable,
          };
        };
        const { Icon, title, clickable } = getVisibilityIcon();
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 24, flexShrink: 0 }}>
              <Tooltip title={title} placement="top">
                <Icon
                  style={{
                    fontSize: 18,
                    fill: "#293461",
                    cursor: clickable ? "pointer" : "default",
                  }}
                  onClick={
                    clickable
                      ? () => {
                        setModal(true);
                        setDatas(rowData);
                      }
                      : undefined
                  }
                />
              </Tooltip>
            </div>
            <HyperLink
              onClick={() => window.open(rowData.url?.url, "_blank")}
              style={{
                fontSize: 13,
                color: "#00838c",
                fontWeight: 500,
              }}
            >
              {rowData.documentNo}
            </HyperLink>
          </div>
        );
      },
    },
    {
      field: "url",
      title: "Document",
      sorting: false,
      width: 300,
      headerStyle: { padding: "12px 16px" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) => (
        <Tooltip title={rowData?.name || ""} placement="top" arrow>
          <div style={{ maxWidth: "100%" }}>
            <HyperLink
              onClick={(e) => {
                e.preventDefault();
                setDocView({
                  state: true,
                  url: rowData?.url?.url,
                  name: rowData?.name,
                  title: rowData?.entity?.title,
                  format: getFileFormat(rowData?.name),
                  pdf: rowData?.name?.toLowerCase().endsWith(".pdf"),
                });
              }}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                fontSize: 13.5,
                fontWeight: 500,
                color: "#00838c",
              }}
            >
              {rowData?.name || "-"}
            </HyperLink>
            {getExhibitId(rowData) && (
              <span style={{ fontSize: 11, color: "#64748b", display: "block", marginTop: 4 }}>
                Exhibit ID: {getExhibitId(rowData)}
              </span>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "exhibitId",
      title: "Exhibit ID",
      sorting: false,
      width: 140,
      headerStyle: { padding: "12px 16px" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) => (
        <div style={{ fontSize: 13, fontWeight: 500, color: "#475569" }}>
          {getExhibitId(rowData) || "—"}
        </div>
      ),
    },
    {
      field: "owner.name",
      title: "Submitted By",
      sorting: false,
      width: 150,
      headerStyle: { padding: "12px 16px" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) => (
        <div style={{ fontSize: 13, fontWeight: 500 }}>
          {rowData?.owner?.name || "-"}
        </div>
      ),
    },
    {
      field: "date",
      title: "Date",
      sorting: false,
      width: 130,
      headerStyle: { padding: "12px 16px" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) => {
        if (!rowData.created_at)
          return <span style={{ color: "#aaa" }}>—</span>;
        const date = moment(parseTimeStamp(rowData.created_at));
        return (
          <div style={{ fontSize: 13, lineHeight: 1.4 }}>
            <div style={{ fontWeight: 500 }}>{date.format("DD/MM/YYYY")}</div>
            <div style={{ color: "#888", fontSize: 11 }}>
              {date.format("hh:mm A")}
            </div>
          </div>
        );
      },
    },
    {
      field: "type",
      title: "Document Type",
      sorting: false,
      width: 220,
      headerStyle: { padding: "12px 16px" },
      cellStyle: { padding: "12px 16px" },
      render: (rowData) =>
        rowData?.entity?.resolutionKind === "arbitration" &&
          viewOnly !== true ? (
          <DocTypeChange
            {...{ rowData, MTRef }}
            documentTypes={caseDetails?.documentCategoryandTypes}
          />
        ) : (
          <StyledTitle style={{ paddingLeft: "25px" }}>
            {rowData?.url?.uploadType || "other"}
          </StyledTitle>
        ),
    },
    {
      field: "extract",
      title: "Extract",
      sorting: false,
      width: 80,
      headerStyle: { padding: "12px 16px", textAlign: "center" },
      cellStyle: { padding: "12px 16px", textAlign: "center" },
      render: (rowData) =>
        rowData?.keywords?.length || rowData?.documentSummary ? (
          <HyperLink
            onClick={() =>
              setView({
                state: true,
                keywords: rowData.keywords,
                documentSummary: rowData.documentSummary,
              })
            }
            style={{
              color: "#0084a3",
              fontWeight: 600,
              fontSize: 13,
              textDecoration: "none",
            }}
          >
            View
          </HyperLink>
        ) : (
          <span style={{ color: "#ccc" }}>—</span>
        ),
    },
    {
      field: "actions",
      title: "",
      sorting: false,
      hidden: viewOnly,
      width: 60,
      headerStyle: { padding: "12px 8px", textAlign: "center" },
      cellStyle: { padding: "12px 8px", textAlign: "center" },
      render: (rowData) => (
        <DeleteIcon
          style={{
            fill: COLORS.LOGOUT_RED,
            fontSize: 20,
            cursor: "pointer",
            opacity: 0.8,
          }}
          onClick={() => openConfirmDelete(rowData)}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.8)}
        />
      ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      const payload = {
        page: query.page + 1,
        perPage: query.pageSize || 10,
      };

      if (ownerType === "claimant") payload.claimantView = true;
      else if (ownerType === "respondent") payload.respondentView = true;
      else payload.commonView = true;

      const stringParams = `?${queryString.stringify(payload)}`;
      getCaseDocument(id, stringParams)
        .then((res) => {
          setResult(res);
          resolve({
            data: res.data || [],
            page: res.page - 1,
            total: res.total || 0,
          });
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), { variant: "error" });
          setResult({ data: [], total: 0, page: 1, perPage: 10, lastPage: 1 });
          resolve({ data: [], page: 0, total: 0 });
        });
    });

  return (
    <>
      <Accordion
        className={classes.root}
        expanded={isExpanded}
        onChange={onAccordionChange}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <AccordionHeading>
            {title} {result?.total ? `(${result.total})` : ""}
          </AccordionHeading>
        </AccordionSummary>
        <AccordionDetails>
          {isExpanded && (
            <TableContainer>
              <CustomTable
                selection={!viewOnly}
                onSelectionChange={(selected) =>
                  setUrls(
                    selected.map((item) => ({
                      url: item?.url?.url,
                      filename: item?.name,
                    })),
                  )
                }
                pluralTitle="Documents"
                singularTitle=""
                columns={columns}
                data={data}
                MTRef={MTRef}
                noToolbar
                pageSize={10}
                hidePagination={result.lastPage === 1}
                state={result}
              />
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>

      <DocVisibilityTypeChange
        modal={modal}
        setModal={setModal}
        rowData={rowData}
        ownerType={ownerType}
        id={id}
        setState={setState}
        MTRef={MTRef}
      />
      <DocViewer docview={docview} setDocView={setDocView} />
      <ViewKeywords view={view} setView={setView} />
      <AlertDialog isOpen={open} {...dialogData} />
    </>
  );
}

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 40px;
  margin-top: 15px;
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
`;

export const TableContainer = styled.div`
  width: 100%;
`;

export const AccordionHeading = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
`;

export const AccordionContainer = styled.div`
  padding: 0 20px;
`;

export const ImageWrapper = styled.div`
  cursor: pointer;
`;

export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
`;

export const StyledTitle = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  width: 200px;
`;

export const Card = styled.div`
  width: 32px;
  display: flex;
  border-radius: 7px;
  align-items: center;
  justify-content: space-between;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
      & .add_circle {
        cursor: not-allowed !important;
      }
    `}

  & .add_circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 23px;
    border-radius: 100%;
    cursor: pointer;
    background-color: rgba(0, 131, 140, 0.13);
  }
`;
